export default __webpack_public_path__ + "static/hinduja-166cdc7debba40a4391ee102068d136f.jpg";